var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    d: "M8.724 8.508a1.47 1.47 0 0 0-1.466 1.475v2.009a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625V9.983c0-.125.1-.225.216-.225h2.542s.042-.008.067-.016v1.25c0 .216.258.325.416.183l2.042-1.858a.238.238 0 0 0 0-.359L11.75 7.1c-.158-.142-.416-.033-.416.183v1.25s-.042-.016-.067-.016H8.724z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B73E8",
    d: "m17.947 8.966-7.041-6.933a1.303 1.303 0 0 0-1.817 0L2.047 8.966a1.3 1.3 0 0 0-.383.908c0 .342.133.667.383.909l7.042 6.925c.25.25.575.367.908.367a1.3 1.3 0 0 0 .909-.367l7.041-6.925c.25-.242.384-.567.384-.909 0-.341-.134-.666-.384-.908m-7.916 7.85s-.05.017-.067 0L2.922 9.858l7.109-6.934 7.041 6.959-7.041 6.925z"
  })));
};
export default SvgNavigation;